module.exports = __webpack_public_path__ + "img/product-placeholder.de6ef210.svg";